import { render, staticRenderFns } from "./Col2.vue?vue&type=template&id=7363244a&scoped=true"
import script from "./Col2.vue?vue&type=script&lang=js"
export * from "./Col2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7363244a",
  null
  
)

export default component.exports